
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faCheckSquare as fasCheckSquare,
    } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
    import {
        faGripVertical as fasGripVertical,
    } from '@fortawesome/pro-solid-svg-icons/faGripVertical';
    import {
        faTimes as farTimes,
    } from '@fortawesome/pro-regular-svg-icons/faTimes';
    import {
        faPlus as farPlus,
    } from '@fortawesome/pro-regular-svg-icons/faPlus';
    import {
        faSquare as farSquare,
    } from '@fortawesome/pro-regular-svg-icons/faSquare';
    import {
        faCheck as farCheck,
    } from '@fortawesome/pro-regular-svg-icons/faCheck';
    import {
        faSpinner as farSpinner,
    } from '@fortawesome/pro-regular-svg-icons/faSpinner';
    import { C1_TAG_VARIANTS } from '@/C1Components/utils/variants';

    export default {
        name: 'C1Tag',

        components: {
            FontAwesomeIcon,
        },

        props: {
            isDraggable: {
                type: Boolean,
                default: false,
            },

            isSelectable: {
                type: Boolean,
                default: false,
            },

            isSelected: {
                type: Boolean,
                default: false,
            },

            hideCheckIcons: {
                type: Boolean,
                default: false,
            },

            hideDragIcon: {
                type: Boolean,
                default: false,
            },

            isActive: {
                type: Boolean,
                default: false,
            },

            isRemovable: {
                type: Boolean,
                default: false,
            },

            isDisabled: {
                type: Boolean,
                default: false,
            },

            isBusy: {
                type: Boolean,
                default: false,
            },

            uppercase: {
                type: Boolean,
                default: false,
            },

            count: {
                type: [String, Number],
                default: '',
            },

            size: {
                type: String,
                default: 'sm',
            },

            variant: {
                type: String,
                default: 'solid',
                validator: value => C1_TAG_VARIANTS.includes(value),
            },

            isStatic: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                icons: {
                    fasGripVertical,
                    farCheck,
                    farTimes,
                    farPlus,
                    farSquare,
                    farSpinner,
                    fasCheckSquare,
                },
            };
        },

        computed: {
            classList() {
                return [
                    'c1-tag',
                    this.getVariantClass,
                    this.getActiveClass,
                    this.getSizeClass,
                    this.getDraggableClass,
                    this.getSelectableClass,
                    this.getUppercaseClass,
                    this.getDisableClass,
                    this.getFontClass,
                    this.getStaticClass,
                ];
            },

            getStaticClass() {
                return this.isStatic ? 'c1-tag--static' : '';
            },

            getVariantClass() {
                return this.variant && !this.isActive ? 'c1-tag--' + this.variant : '';
            },

            getActiveClass() {
                return this.isActive ? 'c1-tag--active' : '';
            },

            getDisableClass() {
                return this.isDisabled ? 'c1-tag--disabled' : '';
            },

            getFontClass() {
                if (this.size === 'md') {
                    return 'text-body-4';
                } else if (this.size === 'lg') {
                    return 'text-body-3';
                } else {
                    return 'text-body-4';
                }
            },

            getSizeClass() {
                if (this.size === 'md') {
                    return 'c1-tag--md';
                } else if (this.size === 'lg') {
                    return 'c1-tag--lg';
                } else {
                    return 'c1-tag--sm';
                }
            },

            getDraggableClass() {
                return this.canDrag ? 'c1-tag--draggable' : '';
            },

            getSelectableClass() {
                return this.canSelect ? 'c1-tag--selectable' : '';
            },

            getUppercaseClass() {
                return this.uppercase ? 'c1-tag--uppercase' : '';
            },

            canSelect() {
                return this.isSelectable && !this.isRemovable && !this.isBusy;
            },

            canDrag() {
                return this.isDraggable && !this.isBusy;
            },

            canRemove() {
                return this.isRemovable && !this.isBusy;
            },

            getCheckedIcon() {
                return this.icons.fasCheckSquare;
            },

            getUncheckedIcon() {
                return this.icons.farSquare;
            },
        },

        methods: {
            onSelect() {
                if (this.canSelect) {
                    this.$emit('select', !this.isSelected);
                }
            },

            onRemove() {
                if (this.canRemove) {
                    this.$emit('remove');
                }
            },
        },
    };
